module.exports = __webpack_public_path__ + "static/img/slide_6_fr.a36ea07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_6_fr.svg
// module id = 4B/y
// module chunks = 0